/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} You_Must_Connect_A_Stripe_AccoInputs */

const en_you_must_connect_a_stripe_acco = /** @type {(inputs: You_Must_Connect_A_Stripe_AccoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You must connect a Stripe account to publish paid listings. The onboarding takes approximately 3 minutes.`)
};

const es_you_must_connect_a_stripe_acco = /** @type {(inputs: You_Must_Connect_A_Stripe_AccoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Debes conectar una cuenta de Stripe para publicar anuncios de pago. El proceso de registro toma aproximadamente 3 minutos.`)
};

const fr_you_must_connect_a_stripe_acco = /** @type {(inputs: You_Must_Connect_A_Stripe_AccoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous devez connecter un compte Stripe pour publier des annonces payantes. L'intégration prend environ 3 minutes.`)
};

const de_you_must_connect_a_stripe_acco = /** @type {(inputs: You_Must_Connect_A_Stripe_AccoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du musst ein Stripe-Konto verbinden, um bezahlte Inserate zu veröffentlichen. Das Onboarding dauert etwa 3 Minuten.`)
};

const ja_you_must_connect_a_stripe_acco = /** @type {(inputs: You_Must_Connect_A_Stripe_AccoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有料の出品を公開するには、Stripeアカウントを接続する必要があります。設定は約3分で完了します。`)
};

const zh_you_must_connect_a_stripe_acco = /** @type {(inputs: You_Must_Connect_A_Stripe_AccoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您必须连接 Stripe 账号才能发布付费商品。入驻流程大约只需 3 分钟。`)
};

const ar_you_must_connect_a_stripe_acco = /** @type {(inputs: You_Must_Connect_A_Stripe_AccoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يجب عليك ربط حساب Stripe لنشر إعلانات مدفوعة. تستغرق عملية الإعداد حوالي 3 دقائق.`)
};

const id_you_must_connect_a_stripe_acco = /** @type {(inputs: You_Must_Connect_A_Stripe_AccoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda harus menghubungkan akun Stripe untuk menerbitkan listing berbayar. Proses pengenalan ini memakan waktu sekitar 3 menit.`)
};

const it_you_must_connect_a_stripe_acco = /** @type {(inputs: You_Must_Connect_A_Stripe_AccoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devi collegare un account Stripe per pubblicare annunci a pagamento. La procedura di attivazione richiede circa 3 minuti.`)
};

const ru_you_must_connect_a_stripe_acco = /** @type {(inputs: You_Must_Connect_A_Stripe_AccoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы должны подключить аккаунт Stripe, чтобы публиковать платные объявления. Регистрация занимает около 3 минут.`)
};

const pt_you_must_connect_a_stripe_acco = /** @type {(inputs: You_Must_Connect_A_Stripe_AccoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você deve conectar uma conta do Stripe para publicar anúncios pagos. O cadastro leva aproximadamente 3 minutos.`)
};

const ko_you_must_connect_a_stripe_acco = /** @type {(inputs: You_Must_Connect_A_Stripe_AccoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`유료 상품을 게시하려면 Stripe 계정을 연결해야 합니다. 가입 절차는 약 3분 정도 소요됩니다.`)
};

/**
* | output |
* | --- |
* | "You must connect a Stripe account to publish paid listings. The onboarding takes approximately 3 minutes." |
*
* @param {You_Must_Connect_A_Stripe_AccoInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const you_must_connect_a_stripe_acco = /** @type {((inputs?: You_Must_Connect_A_Stripe_AccoInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<You_Must_Connect_A_Stripe_AccoInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_you_must_connect_a_stripe_acco(inputs)
	if (locale === "es") return es_you_must_connect_a_stripe_acco(inputs)
	if (locale === "fr") return fr_you_must_connect_a_stripe_acco(inputs)
	if (locale === "de") return de_you_must_connect_a_stripe_acco(inputs)
	if (locale === "ja") return ja_you_must_connect_a_stripe_acco(inputs)
	if (locale === "zh") return zh_you_must_connect_a_stripe_acco(inputs)
	if (locale === "ar") return ar_you_must_connect_a_stripe_acco(inputs)
	if (locale === "id") return id_you_must_connect_a_stripe_acco(inputs)
	if (locale === "it") return it_you_must_connect_a_stripe_acco(inputs)
	if (locale === "ru") return ru_you_must_connect_a_stripe_acco(inputs)
	if (locale === "pt") return pt_you_must_connect_a_stripe_acco(inputs)
	return ko_you_must_connect_a_stripe_acco(inputs)
});